import { render, staticRenderFns } from "./Scanner.vue?vue&type=template&id=60f84a46&"
import script from "./Scanner.vue?vue&type=script&lang=ts&"
export * from "./Scanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports